// extracted by mini-css-extract-plugin
export default {"navItem":"nav-item_navItem__iVbxo","selected":"nav-item_selected__FHufl","inlineNavItem":"nav-item_inlineNavItem__DMM8b"};